import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

/* Product2AttributeValue */
const Product2AttributeValueSchema_ = z.object({
  _id: zExt.objectId(),
  boolean: z.boolean().nullish(),
  decimal: z.number().nullish(),
  integer: z.number().nullish(),
  string: z.string().nullish(),
});
export const Product2AttributeValueSchema: z.ZodType<Product2AttributeValue> =
  Product2AttributeValueSchema_;
export type Product2AttributeValue = z.infer<
  typeof Product2AttributeValueSchema_
>;

const Product2AttributeValueUpsertSchema_ =
  Product2AttributeValueSchema_.extend({ _id: zExt.objectId().optional() });
export const Product2AttributeValueUpsertSchema: z.ZodType<Product2AttributeValueUpsert> =
  Product2AttributeValueUpsertSchema_;
export type Product2AttributeValueUpsert = z.infer<
  typeof Product2AttributeValueUpsertSchema_
>;

export const Product2AttributeType = [
  "boolean",
  "decimal",
  "string",
  "integer",
] as const;
export type Product2AttributeType = (typeof Product2AttributeType)[number];

/* Product2Attribute */
const Product2AttributeSchema_ = z.object({
  _id: zExt.objectId(),
  multiple: z.boolean(),
  name: z.string(),
  team: zExt.objectId(),
  type: createEnum(Product2AttributeType, {
    enumName: "Product2AttributeType",
  }),
  values: z.array(Product2AttributeValueSchema),
});
export const Product2AttributeSchema: z.ZodType<Product2Attribute> =
  Product2AttributeSchema_;
export type Product2Attribute = z.infer<typeof Product2AttributeSchema_>;

const Product2AttributeUpsertSchema_ = Product2AttributeSchema_.extend({
  _id: zExt.objectId().optional(),
  values: z.array(Product2AttributeValueUpsertSchema),
});
export const Product2AttributeUpsertSchema: z.ZodType<Product2AttributeUpsert> =
  Product2AttributeUpsertSchema_;
export type Product2AttributeUpsert = z.infer<
  typeof Product2AttributeUpsertSchema_
>;

const Product2AttributeCreateSchema_ = Product2AttributeSchema_.omit({
  _id: true,
});
export const Product2AttributeCreateSchema: z.ZodType<Product2AttributeCreate> =
  Product2AttributeCreateSchema_;
export type Product2AttributeCreate = z.infer<
  typeof Product2AttributeCreateSchema_
>;
